import { render, staticRenderFns } from "./ModalUpdateBanner.vue?vue&type=template&id=5b65ee62&scoped=true&"
import script from "./ModalUpdateBanner.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65ee62",
  null
  
)

export default component.exports